export function serializeSearchParams(params: object | undefined) {
  return new URLSearchParams(
    Object.entries(params ?? {}).flatMap(([key, value]) => {
      if (value === undefined) {
        return [];
      }

      if (Array.isArray(value)) {
        return value.map((v) => [key, v]);
      }

      return [[key, value]];
    }),
  );
}
